import { getPublicOfEntity } from "services/general";

const parseToRetrievingAcadReinforceForm = data => {
	const {
		idTipoRefuerzo,
		idCurso,
		codCatalogCurso,
		idTutor,
		nombreTutor,
		categoriaSalarial,
		vacantes,
		estudiantesGeneral,
		estudiantesArchivo,
		titulo,
		descripcion,
		destacar,
		idUbicacion,
		idRefuerzoInscripcion,
		idCampusDetalle,
		tipoInstalacion,
		codigoAmbiente,
		otroAmbiente,
		direccion,
		capacidadAmbiente,
		piso,
		idInstalacion,
		diaUnico,
	} = data;
	return {
		acadReinforceTypeId: idTipoRefuerzo,
		course: {
			id: idCurso,
			catalogCode: codCatalogCurso,
		},
		tutor: {
			id: idTutor,
			fullName: nombreTutor,
		},
		payGradeId: categoriaSalarial,
		quantityVacancy: String(vacantes),
		publicLoad: {
			students: estudiantesGeneral
				? {
						publicByCampusIds: estudiantesGeneral.campusIds,
				  }
				: null,
			list: estudiantesArchivo
				? {
						studentsFile: {
							name: estudiantesArchivo.nombre,
							size: 0,
							base64: "",
						},
				  }
				: null,
		},
		title: titulo,
		description: descripcion,
		standOutAcadReinforce: destacar,
		duration: diaUnico
			? {
					date: diaUnico.fecha,
					time: {
						start: diaUnico.horaInicio,
						end: diaUnico.horaFin,
					},
			  }
			: null,
		locationId: idUbicacion || 0,
		zoomInscriptionTypeId: idRefuerzoInscripcion || 0,
		place: idCampusDetalle
			? {
					campusId: idCampusDetalle,
					environmentTypeId: tipoInstalacion,
					otherEnvironment: otroAmbiente,
					environmentCode: codigoAmbiente,
					installationId: idInstalacion,
					address: direccion,
					floor: piso,
					capacity: capacidadAmbiente,
			  }
			: null,
	};
};
const parseToAddOrUpdateRequestStep1 = form => {
	const { title, acadReinforceTypeId, course } = form.part1;
	const { tutor, payGradeId } = form.part2;
	const { quantityVacancy, publicLoad } = form.part3;
	return {
		titulo: title,
		idTipoRefuerzo: acadReinforceTypeId,
		idCurso: course.id,
		codCatalogCurso: course.catalogCode,
		idTutor: tutor.id,
		nombreTutor: tutor.fullName,
		vacantes: quantityVacancy,
		categoriaSalarial: payGradeId,
		...getPublicOfEntity(publicLoad),
	};
};
const parseToUpdateRequestStep2 = form => {
	const { description, standOutAcadReinforce } = form.part1;
	const {
		duration: { date, time },
	} = form.part2;
	const { locationId, zoomInscriptionTypeId, place } = form.part3;
	let body = {
		destacar: standOutAcadReinforce,
		diaUnico: {
			fecha: date,
			horaInicio: time.start,
			horaFin: time.end,
		},
		idUbicacion: locationId,
	};
	if (description.trim())
		body = {
			...body,
			descripcion: description.trim(),
		};
	if (locationId === 1) {
		body = {
			...body,
			idRefuerzoInscripcion: zoomInscriptionTypeId,
		};
	} else if (locationId === 2) {
		const {
			campus,
			environmentTypeId,
			environmentFillingTypeId,
			environment,
			otherEnvironment,
		} = place;
		body = {
			...body,
			idCampusDetalle: campus.id,
			tipoInstalacion: environmentTypeId,
		};
		if (environmentFillingTypeId === 1) {
			body = {
				...body,
				idInstalacion: environment.id,
				codigoAmbiente: environment.environmentCode,
				direccion: environment.address,
				piso: environment.floor,
				capacidadAmbiente: Number(environment.capacity),
			};
		} else if (environmentFillingTypeId === 2)
			body = {
				...body,
				otroAmbiente: otherEnvironment.envName,
				direccion: otherEnvironment.address,
				piso: otherEnvironment.floor,
				capacidadAmbiente: Number(otherEnvironment.capacity),
			};
	}
	return body;
};
const parseToAcadReinforceItem = ({
	idTallerVirtual: id,
	nombre: title,
	destacar: standOut,
	fecha: date,
	duracionHoras: time,
	nombreTutor: tutor,
	ubicacion,
	hoy: today,
	fechaCreacionOEditado: creationOrUpdatedDate,
	fechayHoras,
	estaPendiente: isPending,
	puedeTomarAsistencia: canTakeAttendance,
	inscritos: enrolled,
	estadoPS: state,
	esMasiva: isMassive,
}) => {
	return {
		id,
		title,
		standOut,
		date,
		time,
		dateTime: fechayHoras && {
			date: fechayHoras.fecha,
			time: {
				start: fechayHoras.horaInicio,
				end: fechayHoras.horaFin,
			},
		},
		tutor,
		location: ubicacion
			? {
					zoom: ubicacion.zoom
						? {
								name: ubicacion.zoom.nombre,
								link: ubicacion.zoom.link,
						  }
						: null,
					place: ubicacion.lugar
						? {
								campus: ubicacion.lugar.nombre,
								address: ubicacion.lugar.direccion,
						  }
						: null,
			  }
			: null,
		today,
		isPending,
		creationOrUpdatedDate,
		enrolled,
		canTakeAttendance,
		state,
		isMassive,
	};
};

const helpers = {
	parseToRetrievingAcadReinforceForm,
	parseToAddOrUpdateRequestStep1,
	parseToUpdateRequestStep2,
	parseToAcadReinforceItem,
};

export default helpers;
